import { Helmet } from 'react-helmet'

interface FacebookProps {
  url: string
  type?: string
  title: string
  description: string
  image: string
  name?: string
}
function Facebook({ url, type, title, description, image, name }: FacebookProps) {
  return (
    <Helmet>
      {type && <meta property="og:type" content={type} />}
      {url && <meta property="og:url" content={url} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && description && <meta property="og:image:alt" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {name && <meta property="og:site_name" content={name} />}
    </Helmet>
  )
}

export default Facebook
